import { render, staticRenderFns } from "./Speaker.vue?vue&type=template&id=4f461a7e&scoped=true&functional=true"
import script from "./Speaker.vue?vue&type=script&lang=js"
export * from "./Speaker.vue?vue&type=script&lang=js"
import style0 from "./Speaker.vue?vue&type=style&index=0&id=4f461a7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "4f461a7e",
  null
  
)

export default component.exports